import * as effects from 'redux-saga/effects';
import { IBroadcastActionTypes } from './Types';
import {
  getBroadcast,
  getBroadcastFailure,
  getBroadcastSuccess,
  getCSV,
} from './Actions';
import { Backend } from '../../Backend/Backend';
import { formatDate } from '../../Utils/Time';

function* handleGetBroadcast(action: ReturnType<typeof getBroadcast>) {
  const backend = Backend.getInstance();

  let broadcastPayload: any = action.payload;
  broadcastPayload.startdate = formatDate(action.payload.startdate);
  broadcastPayload.enddate = formatDate(action.payload.enddate);

  try {
    const result = yield effects.apply(backend, backend.getBroadcastPassages, [
      broadcastPayload,
    ]);
    if (result) {
      // todo implement verification result is AdResult
      yield effects.put(getBroadcastSuccess(result));
    } else {
      throw new Error('response is not a result');
    }
  } catch (err) {
    if (err instanceof Error) {
      yield effects.put(getBroadcastFailure(err.message));
      console.log(err);
    } else if (typeof err === 'string') {
      yield effects.put(getBroadcastFailure(err));
      console.log(err);
    } else {
      yield effects.put(getBroadcastFailure('Unknown error occurred'));
      console.log(err);
    }
  }
}
function* handleGetCSV(action: ReturnType<typeof getCSV>) {
  const backend = Backend.getInstance();

  let broadcastPayload: any = action.payload;
  broadcastPayload.startdate = formatDate(action.payload.startdate);
  broadcastPayload.enddate = formatDate(action.payload.enddate);

  try {
    yield effects.apply(backend, backend.downloadCSV, [broadcastPayload]);
  } catch (err) {
    console.log(err);
  }
}

function* watchBroadcast() {
  yield effects.takeEvery(
    IBroadcastActionTypes.GET_BROADCAST,
    handleGetBroadcast
  );
}
function* watchCSV() {
  yield effects.takeEvery(IBroadcastActionTypes.GET_CSV, handleGetCSV);
}

export function* BroadcastSaga() {
  yield effects.all([effects.fork(watchBroadcast)]);
  yield effects.all([effects.fork(watchCSV)]);
}
